export { default } from './request-equipment-service-contact-method';
